import { chakra } from '@chakra-ui/react';
/**
 * The site's rounded pill CTA, matching the legacy `.btn` treatment: hover
 * flashes the lime overlay (::before) and shifts the text terracotta.
 *
 * Color schemes are recipe variants (NOT style-prop overrides) so the hover
 * state reliably outranks the resting colors:
 *   glass — translucent white over imagery (legacy .btn-sage / index buttons)
 *   plain — solid white, ink text (legacy .btn-warm / .btn-submit)
 *   solid — periwinkle, white text; hover darkens to navy (legacy .btn-green)
 */
export const PillButton = chakra('a', {
    base: {
        fontFamily: 'body',
        fontSize: '0.72rem',
        fontWeight: '500',
        letterSpacing: '0.14em',
        textTransform: 'uppercase',
        textDecoration: 'none',
        cursor: 'pointer',
        display: 'inline-block',
        px: '2.4rem',
        py: '0.9rem',
        transition: 'all 0.22s',
        borderRadius: '24px',
        position: 'relative',
        overflow: 'hidden',
        border: 'none',
        '&::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            bg: 'brand.lime',
            opacity: 0,
            pointerEvents: 'none',
        },
        '&:hover::before': {
            animation: 'btnGreenFlash 1.4s ease-out',
        },
    },
    variants: {
        scheme: {
            glass: {
                bg: 'rgba(255,255,255,0.85)',
                color: 'ink.body',
                backdropFilter: 'blur(4px)',
                // !important: hover must outrank the resting colors across Chakra's
                // cascade layers (observed losing without it).
                '&:hover': { background: '#FFFFFF !important', color: '#BC5A4D !important' },
            },
            plain: {
                bg: 'paper.white',
                color: 'brand.ink',
                '&:hover': { color: '#BC5A4D !important' },
            },
            solid: {
                bg: 'brand.mid',
                color: 'paper.white',
                '&:hover': { background: '#1F2D5C !important' },
            },
        },
    },
    defaultVariants: {
        scheme: 'glass',
    },
});
//# sourceMappingURL=pill-button.js.map